// extracted by mini-css-extract-plugin
export var avatarContainer = "_56-1";
export var largeAvatarContainer = "_56-2";
export var smallAvatarContainer = "_56-0";